export const ACTIVATE_TOOLTIP = "ACTIVATE_TOOLTIP";
export const DEACTIVATE_TOOLTIP = "DEACTIVATE_TOOLTIP";
